import React, { useState } from "react";
import "./InputSearchs.css";
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSearch, faTimes } from '@fortawesome/free-solid-svg-icons';
import Modal from 'react-modal';
import { useData } from '../DataContext';
import { ruta } from '../paths';

export default function InputSearchs() {
    const { productos, categorias } = useData();
    const [searchTerm, setSearchTerm] = useState("");
    const [filteredResults, setFilteredResults] = useState([]);
    const [showResults, setShowResults] = useState(false);
    const [noResults, setNoResults] = useState(false);
    const [modalIsOpen, setModalIsOpen] = useState(false);

    const handleSearch = (event) => {
        const searchTerm = event.target.value.toLowerCase();
        setSearchTerm(searchTerm);

        const filteredResults = categorias.map((categoria) => {
            const productosFiltrados = productos.filter((producto) => {
                return (
                    producto.idCategoria === categoria.idCategoria &&
                    (producto.titulo.toLowerCase().includes(searchTerm) ||
                        categoria.categoria.toLowerCase().includes(searchTerm))
                );
            });

            return productosFiltrados.length > 0 ? { categoria, productos: productosFiltrados } : null;
        }).filter(result => result !== null);

        setFilteredResults(filteredResults);
        setShowResults(searchTerm !== "");
        setNoResults(searchTerm !== "" && filteredResults.length === 0);
    };

    const openModal = () => {
        setModalIsOpen(true);
    };

    const closeModal = () => {
        setModalIsOpen(false);
    };

    return (
        <div className="fondo-input">
            <div className="search-container" onClick={openModal}>
                <FontAwesomeIcon icon={faSearch} className="search-icon" />
            </div>
            <Modal isOpen={modalIsOpen} onRequestClose={closeModal} className="modalInput" overlayClassName="overlayInput">
                <div className="search-header">
                    <fieldset className="inputSearch">
                        <FontAwesomeIcon icon={faSearch} className="search-icon" />
                        <input
                            type="text"
                            placeholder="Buscar..."
                            value={searchTerm}
                            onChange={handleSearch}
                            className="input"
                        />
                    </fieldset>
                    <button onClick={closeModal} className="close-search" aria-label="Salir">
                        <FontAwesomeIcon icon={faTimes} />
                    </button>
                </div>
                {showResults && (
                    <div className="modalSearch">
                        {filteredResults.map(({ categoria, productos }) => (
                            <div key={categoria.idCategoria} className="sectionSearch">
                                <h3>{categoria.categoria}</h3>
                                <hr />
                                {productos.map((producto) => (
                                    <div key={producto.idProducto}>
                                        <Link to={ruta(`/producto/${producto.idProducto}/${producto.titulo.replace(/\s+/g, '-')}`)} onClick={closeModal}>
                                            <img src={producto.imagen1} alt="" />
                                            <p>{producto.titulo}</p>
                                        </Link>
                                    </div>
                                ))}
                            </div>
                        ))}
                        {noResults && <p>No se encontraron resultados.</p>}
                    </div>
                )}
            </Modal>
        </div>
    );
}
